import { ExtendedUseFormReturn } from '@Hooks/providers/useFormHooks.tsx';
import { UboResponse, useBoundStore } from '@Store/index';
import { OnboardingFormFields } from '@Types/index.ts';
import { OwnerPercentage } from '../components/OwnerPercentage';
import { UBOManagement } from '../components/UBOManagement';
import { OwnersCenterFormType } from './OwnersCenterForm.types';
import { useMemo } from 'react';

interface OwnersCenterFormProps {
  formMethods: ExtendedUseFormReturn<OwnersCenterFormType>;
  uboList: UboResponse[];
  onEditClick: (uboId: string) => void;
  onAddClick: () => void;
  refetchBusinessOwners: () => void;
}

export const OwnersCenterForm = (props: OwnersCenterFormProps) => {
  const {
    formMethods: {
      control,
      getValues,
      formState: { errors },
      watch,
      trigger,
    },
    uboList,
    onEditClick,
    onAddClick,
    refetchBusinessOwners,
  } = props;

  const { formFieldErrors } = useBoundStore((state) => state.errorSlice);
  const mainOwnerPercentageError =
    formFieldErrors[OnboardingFormFields.OWNER_PERCENTAGE] ||
    errors[OnboardingFormFields.OWNER_PERCENTAGE]?.message;
  const mainOwnerPercentage = watch(OnboardingFormFields.OWNER_PERCENTAGE) || 0;

  const hasMoreThan25PercentOwnershipLeft = useMemo(() => {
    const accOwnersPercent = uboList.reduce((acc, ubo) => acc + ubo.ownershipPercent, 0);
    return 100 - accOwnersPercent - mainOwnerPercentage >= 25;
  }, [mainOwnerPercentage, uboList]);

  return (
    <div className='w-full'>
      <OwnerPercentage control={control} mainOwnerPercentageError={mainOwnerPercentageError} />
      <UBOManagement
        uboList={uboList}
        onEditClick={onEditClick}
        onAddClick={onAddClick}
        control={control}
        getValues={getValues}
        refetchBusinessOwners={refetchBusinessOwners}
        hasMoreThan25PercentOwnershipLeft={hasMoreThan25PercentOwnershipLeft}
        trigger={trigger}
      />
    </div>
  );
};
